<template>
  <Select
    :options="options"
    :keys="keys"
    :values="values"
    :should-select="idOf"
    :disabled="disabled"
    :auto-sort="autoSort"
    :add-item-text="addItemText"
    :add-item-callback="addItemCallback"
    :ignore-form-editable="ignoreFormEditable"
    :model-value="idOf(model)"
    @update:model-value="updateModelValue"
  />
</template>
<script setup>
/*

This component same as Select but it's model is IdObject

*/

import Select from '@/components/select/select.vue'

const model = defineModel()

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  keys: {
    type: String,
    default: 'id',
  },
  values: {
    type: [String, Function],
    default: 'name',
  },
  disabled: { type: Boolean, default: false },
  autoSort: { type: Boolean, default: true },
  addItemText: { type: String },
  addItemCallback: { type: Function },
  ignoreFormEditable: { type: Boolean, default: false },
})

const emit = defineEmits(['update:model-value'])

const idOf = v => (v == null || v === '' ? null : (v?.id ?? v))

function updateModelValue(id) {
  // «Добавить» обрабатывает addItemCallback — model не трогаем
  // (иначе сброс в null ломает модалку DropdownSelect: model.value)
  if (id === '__addItem') {
    return
  }
  if (id == null || id === '') {
    emit('update:model-value', null)
    return
  }
  const opt = (props.options || []).find(o => String(o?.id) === String(id))
  if (opt && typeof opt === 'object') {
    emit('update:model-value', { ...opt, id: Number(opt.id) || opt.id })
    return
  }
  emit('update:model-value', { id: Number(id) || id })
}
</script>
